/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminBillingProfileDetail,
  AdminV1OrganizationsPaymentsBillingProfilesListParams,
  PaginatedBillingProfileList
} from '.././model';

import adminV1OrganizationsPaymentsBillingProfilesListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsBillingProfilesRetrieveMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsBillingProfilesList = (
    organizationId: number,
    params?: AdminV1OrganizationsPaymentsBillingProfilesListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsBillingProfilesListMutator<PaginatedBillingProfileList>>,) => {
      return adminV1OrganizationsPaymentsBillingProfilesListMutator<PaginatedBillingProfileList>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/billing-profiles/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsBillingProfilesRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsBillingProfilesRetrieveMutator<AdminBillingProfileDetail>>,) => {
      return adminV1OrganizationsPaymentsBillingProfilesRetrieveMutator<AdminBillingProfileDetail>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/billing-profiles/${id}/`, method: 'GET'
    },
      options);
    }
  export type AdminV1OrganizationsPaymentsBillingProfilesListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsBillingProfilesList>>>
export type AdminV1OrganizationsPaymentsBillingProfilesRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsBillingProfilesRetrieve>>>
